import { getConsent, setConsent, subscribe } from '@linecorp/dosi-analytics';
import { useEffect, useState } from 'react';

export const useConsentStore = () => {
  const [data, setData] = useState(getConsent());

  useEffect(() => {
    const unsubscribe = subscribe({
      onStateChange: ({ consent }) => setData(consent),
    });
    return unsubscribe;
  }, []);

  return { ...data, accept: setConsent };
};
